/**
 * buildTaskRequest — the ONE place the "reminder 1 day before due" task-creation
 * convention lives (TASK-575). Both the signal→task edge (useMakeTaskFromSignal)
 * and the propose_action Apply card (ActionProposalCard) build a TaskCreateRequest
 * the same way: cap the title, and if there's a due date, remind 1 day before it —
 * which is exactly what the reminder sweep needs (assignee_user_id + reminder_datetime).
 *
 * Caller-specific concerns stay in the callers: due-date policy (proposal-supplied vs
 * always +7d), task_type validation, and success/error feedback (toast vs local state).
 */

import type { TaskCreateRequest, TaskType, TaskPriority } from '../types/tasks';

const DAY_MS = 24 * 60 * 60 * 1000;

export interface BuildTaskInput {
  title: string;
  description?: string;
  task_type: TaskType;
  priority?: TaskPriority;
  due_date?: string;
  client_id?: string;
  source?: string;
  related_entity_type?: string;
  related_entity_id?: string;
  assignee_user_id?: string;
}

export function buildTaskRequest(input: BuildTaskInput): TaskCreateRequest {
  const reminder = input.due_date
    ? { scheduled_at: new Date(new Date(input.due_date).getTime() - DAY_MS).toISOString() }
    : undefined;

  return {
    title: input.title.slice(0, 500),
    description: input.description,
    task_type: input.task_type,
    priority: input.priority ?? 'medium',
    due_date: input.due_date,
    client_id: input.client_id,
    source: input.source,
    related_entity_type: input.related_entity_type,
    related_entity_id: input.related_entity_id,
    assignee_user_id: input.assignee_user_id,
    reminder,
  };
}
